var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgF2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#EFF3FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 17.8369V23.0001C32.5 23.7002 32.5 24.0502 32.6362 24.3176C32.7561 24.5528 32.9473 24.744 33.1825 24.8638C33.4499 25.0001 33.7999 25.0001 34.5 25.0001H39.6632M35 31.25H25M35 36.25H25M27.5 26.25H25M32.5 17.5H26C23.8998 17.5 22.8497 17.5 22.0475 17.9087C21.3419 18.2683 20.7683 18.8419 20.4087 19.5475C20 20.3497 20 21.3998 20 23.5V36.5C20 38.6002 20 39.6503 20.4087 40.4525C20.7683 41.1581 21.3419 41.7317 22.0475 42.0913C22.8497 42.5 23.8998 42.5 26 42.5H34C36.1002 42.5 37.1503 42.5 37.9525 42.0913C38.6581 41.7317 39.2317 41.1581 39.5913 40.4525C40 39.6503 40 38.6002 40 36.5V25L32.5 17.5Z",
    stroke: "#3375B9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgF2);
export default __webpack_public_path__ + "static/media/f2.64c6ff3943ff340b4c81170003469a28.svg";
export { ForwardRef as ReactComponent };